<div>
  <app-sort-table [columnDefs]="columns" [rows]="rows" [excelEnabled]="true"> </app-sort-table>
</div>
